import { instance } from './config';

export const getPaymentById = (tokenId) => {
   return instance.get(`/payment/id/${tokenId}`);
};

export const getPaymentByTransactionId = (transactionId) => {
   return instance.get(`/payment/transaction/${transactionId}`);
};

export const getPaymentsByDates = (startDate, endDate, pageNumber) => {
   return instance.get('/payment/dates', {
      params: {
         startDate: startDate,
         endDate: endDate,
         pageNumber,
      },
   });
};

export const getPaymentsByDatesCriteria = (startDate, endDate, keySearch, keyValue, pageNumber) => {
   return instance.get('/payment/dates_criteria', {
      params: {
         startDate: startDate,
         endDate: endDate,
         keySearch: keySearch,
         keyValue: keyValue,
         pageNumber: pageNumber,
      },
   });
};
